import Vue from "vue";

import { DEFAULT_LOCALE } from "@/constants";

export const localizedLink = {
  methods: {
    localizedLink(path, inLocale = null) {
      const locale = inLocale || this.$i18n.locale;

      let name,
        query,
        hash = null;

      if (typeof path === "object") {
        name = path.name;
        query = path.query;
        hash = path.hash;
      } else {
        name = path;
      }

      const prefixedPath =
        locale !== DEFAULT_LOCALE ? `localized-${name}` : name;

      const routerObj = {
        name: prefixedPath,
        params: { lang: locale }
      };

      if (hash) {
        Object.assign(routerObj, { hash: `#${hash}` });
      }

      if (query) {
        Object.assign(routerObj, { query: query });
      }

      return routerObj;
    }
  }
};

export const swaggerUrl = {
  methods: {
    swaggerUrl(forHomepage = false) {
      const file = "swagger.json";
      const pathname = location.pathname.replace(/\/$/, "");
      const url = `${location.origin}${pathname}`;
      let path = this.$i18n.locale !== DEFAULT_LOCALE ? "/../../" : "/../";

      if (forHomepage) {
        path = this.$i18n.locale !== DEFAULT_LOCALE ? "/../" : "/";
      }
      return url + path + file;
    }
  }
};

export const metadataUrl = {
  methods: {
    metadataUrl() {
      const file = "metadata.json";
      const pathname = location.pathname.replace(/\/$/, "");
      const url = `${location.origin}${pathname}`;
      const path = this.$i18n.locale !== DEFAULT_LOCALE ? "/../../" : "/../";
      return url + path + file;
    }
  }
};

export const orgConfig = {
  methods: {
    orgConfig(key) {
      return orgConfiguration(this.organizationConfig, key);
    }
  }
};

export const orgConfiguration = (organizationConfig, key) => {
  if (!window.__PRERENDER_INJECTED) {
    return getNestedValue(organizationConfig, key);
  } else {
    return "${" + key + "}";
  }
};

function getNestedValue(obj, key) {
  return key.split(".").reduce(function(result, key) {
    return result[key];
  }, obj);
}

Vue.mixin({ methods: { ...orgConfig.methods, ...localizedLink.methods } });
